var map = {
	"./3-2.png": 44766,
	"./4-1.jpg": 24838,
	"./bc9324842e643182f271a3b84114c329.jpg": 4243,
	"./d4e8342dfd4d7ede203f16f511eeb3aa.jpg": 90501,
	"./f2a2285fb4e1ce0af46ab17d27d0d9d6.jpg": 79968,
	"./new5-1.png": 20903,
	"./new5-2.png": 52428,
	"./new5-3.png": 35317
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13408;